import { MenuItem } from "@app/types";
import { MenuLabel, RoutePath } from "./common.const";
import NotebookIcon from "@app/icons/notebook";
import WalletIcon from "@app/icons/wallet";
import WithdrawIcon from "@app/icons/withdraw";
import StatisticsIcon from "@app/icons/statistics";
import FAQIcon from "@app/icons/faq";

export const MenuList: readonly MenuItem[] = [
  {
    linkTo: RoutePath.STATISTICS,
    icon: <StatisticsIcon />,
    label: MenuLabel.STATISTICS,
  },
  {
    linkTo: RoutePath.BOOK_MANAGEMENT,
    icon: <NotebookIcon />,
    label: MenuLabel.BOOK_MANAGEMENT,
  },
  // {
  //   linkTo: RoutePath.BANK_MANAGEMENT,
  //   icon: <CardIcon />,
  //   label: MenuLabel.BANK_MANAGEMENT,
  // },
  // {
  //   linkTo: RoutePath.VOICE_TRAIN_MANAGEMENT,
  //   icon: <MicrophoneIcon />,
  //   label: MenuLabel.VOICE_TRAIN_MANAGEMENT,
  // },
  {
    linkTo: RoutePath.WALLET_MANAGEMENT,
    icon: <WalletIcon />,
    label: MenuLabel.WALLET_MANAGEMENT,
  },
  {
    linkTo: RoutePath.WITHDRAW_MANAGEMENT,
    icon: <WithdrawIcon />,
    label: MenuLabel.WITHDRAW_MANAGEMENT,
  },
  {
    linkTo: RoutePath.FAQ_MANAGEMENT,
    icon: <FAQIcon />,
    label: MenuLabel.FAQ_MANAGEMENT,
  },
];
